import PropTypes from 'prop-types';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Modal from '../../components/modal';
import Confirmation from '../../components/confirmation';
import { DiscardIcon } from '../../components/icons';
import { closeModal } from '../../actions/close-modal';
import withTranslate from '../../hoc/with-translate';

export const DiscardPostModal = ({ closeModal, discardPost, t }) =>
  <Modal onClose={closeModal}>
    <Confirmation
      icon={DiscardIcon}
      title={t('discard-post-modal.discard-post')}
      confirm={t('discard-post-modal.confirm')}
      cancel={t('discard-post-modal.cancel')}
      onConfirm={discardPost}
      onCancel={closeModal}
    >
      <p>
        {t('discard-post-modal.are-you-sure')}
      </p>
    </Confirmation>
  </Modal>;

DiscardPostModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  discardPost: PropTypes.func.isRequired,
  t: PropTypes.func,
};

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      closeModal,
      discardPost: () => closeModal(ownProps.categorySlug),
    },
    dispatch
  );

export default connect(undefined, mapDispatchToProps)(withTranslate(DiscardPostModal));



// WEBPACK FOOTER //
// ./app/containers/discard-post-modal/discard-post-modal.js